import classNames from 'classnames';
import { bool, node, object, string } from 'prop-types';
import React from 'react';
import NamedLink from '../NamedLink/NamedLink';

import css from './PrismicSectionHero.module.css';

const PrismicSectionHero = props => {
  const {
    children,
    className,
    rootClassName,
    disableLink,
    backgroundImage,
    linkParams,
    alt,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  const handleClickSectionHero = e => {
    disableLink && e.preventDefault();
  };

  return (
    <div className={classes}>
      <img className={css.heroImage} src={backgroundImage} alt={alt} />
      <NamedLink
        name="SingleBlogPage"
        params={linkParams}
        className={classNames(css.overlay, { [css.disableLink]: disableLink })}
        onClickFn={handleClickSectionHero}
      >
        {children}
      </NamedLink>
    </div>
  );
};

PrismicSectionHero.propTypes = {
  rootClassName: string,
  className: string,
  disableLink: bool,
  children: node,
  backgroundImage: string,
  linkParams: object,
  alt: string,
};

PrismicSectionHero.defaultProps = {
  rootClassName: null,
  className: null,
  disableLink: false,
  children: null,
  backgroundImage: null,
  linkParams: null,
  alt: null,
};

export default PrismicSectionHero;
